export default "__VITE_ASSET__CnNl8ZuS__"